// let scroll = new SmoothScroll('a[href*="#"]', {
// 	speed: 500
// });

document.addEventListener(
	"DOMContentLoaded", () => {
		new Mmenu("#mobile-main-nav", {
			"offCanvas": {
				"position": "left",

				page: {
					selector: "#page-wrapper"
				}
			},

			navbar: {
				title: "Меню"
			},

			"theme": "light",
			"navbars": [{
				title: 'Меню',
			}]
		});
	}
);

// Мобильная липкая шапка
jQuery(window).scroll(function () {
	let stickyHeader = $('.js-mobile-sticky-header');

	if ($(this).scrollTop() > 40) {
		stickyHeader.addClass("js-mobile-sticky-header--sticky");
	} else {
		stickyHeader.removeClass("js-mobile-sticky-header--sticky");
	}
});
